import styled, { css } from "styled-components";
import { themeConfig } from "config/theme/config";
export const ThreeRem: string = "3rem";

export const NavContainer = styled.section`
	position: sticky;
	display: flex;
	width: 100vw;
	min-height: ${ThreeRem};
	background: #fff;
	z-index: 10;
`;
const BaseLinkBoxWrap = styled.div`
	min-height: ${ThreeRem};
	padding-left: 0.75rem;
	overflow-x: scroll;
	flex: 1;

	a {
		display: inline-flex;
		font-size: 0.875rem;
		font-weight: 400;
		color: ${props => props?.theme?.mainFontColor};
		line-height: ${ThreeRem};
		margin-right: 0.75rem;
	}
`;
export const LinkBox = styled(BaseLinkBoxWrap)`
	a.active {
		font-weight: 600;
		color: #3e82f7;
		border-bottom: 2px solid #3e82f7;
	}
`;

export const ShowBox = styled(BaseLinkBoxWrap)`
	font-size: 0;
`;

interface ArrowBoxProps {
	isUp: boolean;
}

export const ArrowBox = styled.div`
	min-width: ${ThreeRem};
	height: ${ThreeRem};
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		width: 0.5625rem;
		height: 1rem;
		${(props: ArrowBoxProps) => {
			if (props.isUp) {
				return css`
					transform: rotate(90deg);
				`;
			}
			return css`
				transform: rotate(-90deg);
			`;
		}}
	}
`;

// edm 样式
export const wrapStyle: React.CSSProperties = {
	position: "sticky",
	display: "flex",
	minHeight: `${ThreeRem}`,
	background: "#fff",
	zIndex: 2,
	justifyContent: "space-between",
};
export const linkStyle: React.CSSProperties = {
	fontSize: "0.875rem",
	fontWeight: 400,
	color: `${themeConfig.mainFontColor}`,
	lineHeight: `${ThreeRem}`,
	marginRight: "0.75rem",
};
export const showStyle: React.CSSProperties = {
	display: "inline-block",
	fontSize: "0.875rem",
	fontWeight: 400,
	fontFamily: "Avenir-Heavy",
	color: `${themeConfig.mainFontColor}`,
	lineHeight: `${ThreeRem}`,
	marginRight: "0.75rem",
};
